import { render, staticRenderFns } from "./updateParcelType.vue?vue&type=template&id=137b5f52&"
import script from "./updateParcelType.vue?vue&type=script&lang=js&"
export * from "./updateParcelType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports